export function makeInitialSettings() {

  return {
    chartFormatting: {
        legend: {
            show: true,
            labelType: 'shortTitle',
            icon: 'rect',
            type: 'scroll',
            orient: 'horizontal',
            left: 'center',
            top: 'bottom',
            padding: 5,            
        },
        series: [],
        tableColumns: [],
        kpiCard: {
            id: null,
            layout: 'standard',
            valueFontSize: 'xl',
            numberFormat: { type: 'ShortNumber', decimals: 2, currency: 'EUR', locale: 'en' },
            conditionalFormattingRules: [],
            conditionalFormattingValue: 'value',
            stats: [],
        },
        xAxis: {
            show: true,
            type: 'category',
            position: 'bottom',
            axisTick: {
                alignWithLabel: true,
                interval: 'auto',
            },
            axisLabel: {
                format: 'LongDate',
                separator: '-',
                customFormat: '',
                rotate: 60,
            }
        },
        yAxis: {
            show: true,
            type: 'value',
            position: 'left',
            alignTicks: false,
            axisLabel: {
                format: 'LongDate',
                separator: '-',
                customFormat: '',
                rotate: 0,
            }
            
        },
        yAxisSecondary: {
            show: true,
            type: 'value',
            position: 'right',
            alignTicks: true,
            axisLabel: {
                format: 'LongDate',
                separator: '-',
                customFormat: '',
                rotate: 0,
            }
        },
        tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
            },
            numberFormat: {
                type: 'Number', // Options: 'Number', 'Percent', 'ShortNumber', 'Currency', 'ShortCurrency'
                decimals: 2, // Number of decimal places
                currency: 'EUR', // Currency code for currency formatting
                locale: 'en' // Locale for number formatting
            },
            backgroundColor: '#ffffff',
            borderColor: '#ccc',
            borderWidth: 1,
            padding: 10,
            textStyle: {
                color: '#000',
                fontSize: 16,
                fontWeight: 'normal',
                lineHeight: 20,
                align: 'left',
                verticalAlign: 'top',
            },

        },
    },
    chartSettings: {
        title: null, 
        subtitle: null,
        pivotConfig: {
            x: [],
            y: ['measures'],
        },
        kpiCardOptions: {
            valuePrefix: '',
            valueSuffix: '',
            footerText: '',
            comparisonText: '',
            displayComparisonValue: true,
            displayComparisonDelta: true,

        },
        tableOptions: {
            styling: {
                size: 'normal',
                fontSize: 'md',
                showGridLines: false,
                stripedRows: false
            },
            interactivity: {
                selectable: false,
                sortable: false,
                filterable: false,
                exportable: false,
                pagination: {
                    paginator: false,
                    rows: 10,
                    rowsPerPageOptions: [10,20,30,40,50]
                }
            }
        }
        
    },
    chartDimensions: {
        height: '100%',
        minHeight: '500px',
        maxHeight: '1000px',
        width: '100%',
        minWidth: '200px',
        maxWidth: '2500px'
    }
  };
}